<template>
  <section class="section-container">
    <div class="content-wrapper">
      <div class="content-heading">
        {{ $t('tenderexport.title') }}
      </div>
      <div class="card" v-if="!loader">
        <div class="table-responsive">
          <table class="table">
            <tbody>
            <tr>
              <td class="b0">
                <p class="h4 mt-0">
                  <span class="align-middle text-bold link-unstyled">{{ $t('tenderexport.tender') }} {{ tender.tender_code }}</span>
                  <span
                    class="rounded badge bg-success-light px-4 ml-2 text-sm d-lg-inline"
                    v-if="tender.export_data && tender.export_data.status==='SUCCESS'">
                    <span class="text-white">{{ $t('tenderexport.success') }} {{ tender.export_data.created | formatDateTime }}</span>
                  </span>
                  <span
                    class="rounded badge bg-danger-light px-4 ml-2 text-sm d-lg-inline"
                    v-if="tender.export_data && tender.export_data.status==='FAILED'">
                    <span class="text-white">{{ $t('tenderexport.failed') }} {{ tender.export_data.created | formatDateTime }}</span>
                  </span>
                  <span class="rounded badge bg-info-light px-4 ml-2 text-sm d-lg-inline"
                    v-if="tender.group_name">
                    <span class="text-white" :title="$t('tenderexport.group')">{{ tender.group_name }}</span>
                  </span>
                </p>
                <div class="text-muted">
                  <div class="row">
                    <div class="col-sm-4">
                      <span><b>{{ $t('tenderexport.start') }}:</b> {{ tender.start | formatDateTime }}</span><br>
                      <span><b>{{ $t('tenderexport.end') }}:</b> {{ tender.finish | formatDateTime }}</span>
                    </div>
                    <div class="col-sm-4">
                      <span><b>{{ $t('tenderexport.created') }}:</b> {{ tender.creator_name }}</span><br>
                      <span><b>{{ $t('tenderexport.approver') }}:</b> {{ tender.approver_name}}</span>
                    </div>
                    <div class="col-sm-4">
                      <span><b>{{ $t('tenderexport.approved') }}:</b> {{ tender.approved | formatDateTime }}</span><br>
                      <span><b>{{ $t('tenderexport.warehouse') }}:</b> {{ tender.warehouse_name }} ({{ tender.warehouse_address }})</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="tender.export_data">
        <div class="card card-default" v-for="row in tender.export_data.orders" :key="row.order_code" v-if="!loader">
        <div class="card-header bg-light">
          <div class="row">
            <div class="col-sm-3"><b>{{ $t('tenderexport.order') }}:</b> {{ row.order_code }}
              <span
                v-if="row.export_code"
                class="rounded badge-success text-sm px-2 ml-1"
                :title="$t('tenderexport.export-number')">{{ row.export_code }}
              </span>
              <span
                v-if="!row.export_code"
                class="rounded badge-danger text-sm px-2 ml-1"
                :title="$t('tenderexport.export-number')">{{ $t('tenderexport.empty') }}
              </span>
            </div>
            <div class="col-sm-3"><b>{{ $t('tenderexport.supplier-name') }}:</b> {{ row.supplier.name }}</div>
            <div class="col-sm-3"><b>{{ $t('tenderexport.supplier-mail') }}:</b> {{ row.supplier.email }}</div>
            <div class="col-sm-3"><b>{{ $t('tenderexport.supplier-phone') }}:</b> {{ row.supplier.phone }}</div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive mb-2">
            <table class="table table-hover">
              <thead>
              <tr>
                <th class="wd-xs">#</th>
                <th class="wd-sd">{{ $t('tenderexport.part-code') }}</th>
                <th class="wd-xl">{{ $t('tenderexport.name') }}</th>
                <th class="wd-sd">{{ $t('tenderexport.producer') }}</th>
                <th class="wd-sd">{{ $t('tenderexport.availability') }}</th>
                <th class="wd-sd">{{ $t('tenderexport.price') }}</th>
                <th class="wd-sd">{{ $t('tenderexport.qty') }}</th>
                <th class="wd-sd">{{ $t('tenderexport.total') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(d, index) in row.details">
                <td>{{ index+1 }}</td>
                <td>
                    {{ d.part.code }}
                </td>
                <td>{{ d.part.name }}
                  <button
                    class="btn btn-link pl-1 pt-1"
                    @click="open_modal(d.part.name, d.part.tags)"
                    v-if="d.part.tags">
                    <i class="fa icon-info ml-1"></i>
                  </button>
                </td>
                <td>{{ d.proposal.producer }}</td>
                <td>{{ d.proposal.delivery_date }}</td>
                <td>{{ d.proposal.price.toFixed(4).replace(/0{0,2}$/, '') }} {{ $t('global.euro-sign') }}</td>
                <td>{{ d.proposal.ordered_qty }}</td>
                <td>{{ d.proposal.total.toFixed(2) }} {{ $t('global.euro-sign') }}</td>
              </tr>
              <tr>
                <td colspan="6"></td>
                <td class="text-bold">{{ $t('tenderexport.total') }}</td>
                <td class="text-bold">{{ row.grand_total.toFixed(2) }} {{ $t('global.euro-sign') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>

      <div class="card card-default" v-if="!loader">
        <div class="card-body">
          <div>
            <button
              v-if="directo.is_active"
              class="btn btn-outline-green fa-pull-right ml-2"
              :title="$t('tenderexport.export')"
              @click="exportDirecto(tender.id)">
              <i class="fas fa-share"></i> {{ $t('tenderexport.export') }}
            </button>

            <router-link
              :to="{name: 'tender_view', params: {id: tender.id}}"
              class="btn btn-outline-warning fa-pull-right ml-2">
              <i class="fas fa-arrow-left"></i> {{ $t('tenderexport.back-to-tender') }}
            </router-link>

          </div>
        </div>
      </div>
    </div>

    <modal v-if="showModal">
      <h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
      <div class="modal-body" slot="modal-body">
        <p class="text-bold">{{ $t('modal.section1.header') }}</p>
        <p>{{ modal_data_1 }}</p>
        <p class="text-bold">{{ $t('modal.section2.header') }}</p>
        <p>{{ modal_data_2}}</p>
      </div>
      <div slot="modal_buttons">
        <button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
      </div>
    </modal>

    <div class="col-xl-12 text-center" v-if="loader">
      <div class="card">
        <div class="card-body loader-demo d-flex align-items-center justify-content-center">
          <div class="ball-beat">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import api from '@/api'
import Modal from '@/components/Modal.vue'
import message from '@/message'

const getData = (id, route, next) => {
  Promise.all([
    api.get(`/tenders/${id}/?export_data=true`),
    api.get('/modules/?name__exact=Directo')
  ])
    .then(([tender, directo]) => {
      next({
        tender: tender.data,
        directo: directo.data.results[0]
      })
    })
}

export default {
  components: {
    modal: Modal
  },
  data () {
    return {
      tender: {},
      showModal: false,
      modal_data_1: null,
      modal_data_2: null,
      interval: null,
      module_export_log_id: null,
      loader: false,
      directo: {
        is_active: false
      }
    }
  },
  mounted () {
    this.$parent.menu = 'tenders'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    check_directo_export_status () {
      api.get('/directo_export_status/', {
        params: {
          'module_export_log_id': this.module_export_log_id
        }
      })
        .then(resp => {
          if (resp.data.status !== 'PROGRESS') {
            clearInterval(this.interval)
            this.loader = false
            api.get(`/tenders/${this.tender.id}/?export_data=true`)
              .then(resp => {
                this.tender = resp.data
              })
          }
        })
    },
    exportDirecto (id) {
      if (this.tender.export_data.status === 'SUCCESS') {
        this.$swal({
          type: 'warning',
          title: this.$i18n.t('tenderexport.are-you-sure'),
          text: this.$i18n.t('tenderexport.are-you-sure-text-cancel'),
          showCancelButton: true
        })
          .then((choice) => {
            if (choice.value) {
              api.post('/directo_export_manual/', null, {
                params: {
                  'tender_id': id
                }
              })
                .then(resp => {
                  this.module_export_log_id = resp.data.module_export_log_id
                  this.loader = true
                  this.interval = setInterval(this.check_directo_export_status, 1000)
                })
                .catch(() => {
                  message.error(this.$i18n.t('tenderexport.export-failed'))
                })
            }
          })
      } else {
        api.post('/directo_export_manual/', null, {
          params: {
            'tender_id': id
          }
        })
          .then(resp => {
            this.module_export_log_id = resp.data.module_export_log_id
            this.loader = true
            this.interval = setInterval(this.check_directo_export_status, 1000)
          })
          .catch(() => {
            message.error(this.$i18n.t('tenderexport.export-failed'))
          })
      }
    },
    close_modal () {
      this.showModal = false
    },
    open_modal (data1, data2) {
      this.showModal = true
      this.modal_data_1 = data1
      this.modal_data_2 = data2
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/TenderExport.vue